import React from 'react';
import PropTypes from 'prop-types';

import { BoxMessage } from '@components/Messages';
import infoIcon from '@assets/icons/info-yellow.svg';
import DonationWarningWrapper from './components/DonationWarningWrapper';

import connect from './connect';

function DonationWarning({ donationWarningMessage }) {
  return (
    <>
      {donationWarningMessage && (
        <DonationWarningWrapper>
          <BoxMessage title={donationWarningMessage} imgSrc={infoIcon} />
        </DonationWarningWrapper>
      )}
    </>
  );
}

DonationWarning.propTypes = {
  donationWarningMessage: PropTypes.string,
};

export default connect(DonationWarning);
